import React from "react";
import "./Footer.scss";

import signature from "../../assets/signature.png";
import instagram from "../../assets/instagram.svg";
import email from "../../assets/mail.svg";
import { LanguageSwitcher } from "../LanguageSwitcher/LanguageSwitcher";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="column text-column">
          <p>©2025 KUKOLJ TEAM MASTERCLASS</p>
        </div>

        <div className="column logo-column">
          <img src={signature} alt="Logo" className="logo" />
        </div>

        <div className="column social-media-column">
          <div className="social-icons">
            {/* <a
              href="https://facebook.com/kukoljmasterclass"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="Facebook" />
            </a> */}
            <a
              href="https://instagram.com/kukoljmasterclass"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <img src={instagram} className="instagram" alt="Instagram" />
            </a>
            <a href="mailto:kukoljmasterclass@gmail.com" className="social-icon">
              <img src={email} alt="Email" />
            </a>
          </div>
        </div>
      </div>
      <LanguageSwitcher className="language-switcher--desktop-nav" />
    </footer>
  );
}

export default Footer;
